import { Box, Button, Flex, Stack, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { ChoosePlanModal } from "../PlanModals";

import { TextSerif } from "@/components/elements";

import type { FC } from "react";

interface ContentLockerProps {
  showPlanModal: boolean;
  openPlanModal: () => void;
  closePlanModal: () => void;
}

export const ContentLocker: FC<ContentLockerProps> = ({
  showPlanModal,
  openPlanModal,
  closePlanModal,
}) => {
  const { t } = useTranslation();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return (
    <Stack
      key={`content-locker-theme_${isDark ? "dark" : "light"}`}
      p="md"
      gap="md"
      style={{
        userSelect: "none",
      }}
    >
      <Box bg={isDark ? ".primary.9" : "white"}>
        <Text fz="1.5em" ta="center">
          {t("plans.contentLocker.title")}
        </Text>
        <TextSerif fz="sm" ta="center">
          {t("plans.contentLocker.description")}
        </TextSerif>
      </Box>
      {/* Footer actions */}
      <Flex justify="center" w={{ base: 400, md: 450 }} gap="lg" mx="auto" py="lg" maw="100%">
        {/* 
          This button is commented out as defined in designs, but currently there is no "Learn more" section for now. It can be easily re-enabled when needed.
          
          <Button
            variant="outline"
            w="50%"
            maw="100%"
            aria-label={t("plans.contentLocker.learn_more")}
          >
            {t("plans.contentLocker.learnMoreText")}
          </Button> 
        */}

        <Button
          w="50%"
          maw="100%"
          onClick={openPlanModal}
          aria-label={t("plans.contentLocker.upgrade")}
        >
          {t("plans.contentLocker.upgradeText")}
        </Button>
      </Flex>

      <ChoosePlanModal
        isOpen={showPlanModal}
        onClose={closePlanModal}
        title={t("plans.changePlanAnytime")}
      />
    </Stack>
  );
};
